import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackGuestActivity } from "@/lib/guestTracking";

// Tracks route changes as privacy-minimal page_view events.
// Intentionally does NOT include page_url/referrer/UTM/device/geo.
export function ViewTracker() {
  const location = useLocation();
  const lastPathRef = useRef<string | null>(null);

  useEffect(() => {
    const path = location.pathname;
    if (!path) return;
    if (lastPathRef.current === path) return;
    lastPathRef.current = path;
    trackGuestActivity("page_view", {});
  }, [location.pathname]);

  return null;
}
